<template>
  <div class="list_page infinite-list" v-infinite-scroll="load" :infinite-scroll-disabled="disabled">
    <h1>{{ type_name }}</h1>
    <el-divider />
    <BaseArticle_card v-for="item in arc_list" :key="item.ID" :id="item.ID" :arc_title="item.post_title" :desc="item.post_content" />
  </div>
</template>

<script>
import article_card from '../model/article_card.vue';
import {computed, inject, ref,watch} from "vue";
import axios from "axios";
import { useRoute } from 'vue-router';
export default {
  name: 'ListView',
  props: {
    msg: String
  },
  setup(){
    var api_url=inject('api_url')
    const arc_list=ref([]);
    const type_name = ref("");
    const page = ref(1);
    const loading = ref(false);
    const noMore = ref(false);
    const disabled = computed(() => loading.value || noMore.value)
    const route = useRoute();

    watch(() => route.params, () => {
      axios.get(api_url+"article_list?tid="+route.params.id+"&p=1")
          .then(response => {
            if(response.data.status===1)
            {
              arc_list.value=response.data.list;
              type_name.value=response.data.data.name;
              page.value=2;
              loading.value = false;
            }
          })
          .catch(error => {
            console.error('There was an error!', error);
          });
    }, { immediate: false });

    const load = () => {
      loading.value = true;
      axios.get(api_url+"article_list?tid="+route.params.id+"&p="+page.value)
          .then(response => {
            if(response.data.status===1)
            {
              arc_list.value=arc_list.value.concat(response.data.list);
              type_name.value=response.data.data.name;
              page.value=page.value+1;
              loading.value = false;
            }
          })
          .catch(error => {
            console.error('There was an error!', error);
          });

    }
    return {
      arc_list,
      load,
      disabled,
      type_name
    }
  },
  watch(){

  },
  components: {
    BaseArticle_card: article_card,
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
